import { parseDate, parsePerson } from './utils'

export default class Note {
	static fromJSON(json) {
		return new Note(json.id)
			.withCreatedAt(json.createdAt)
			.withAuthor(json.author)
			.withNote(json.note)
			.withReminderDate(json.reminderDate)
			.withReminder(json.reminder)
			.withEmphasize(json.emphasize)
			.withProcessId(json.processId)
	}

	constructor(id) {
		this.id = id
		this.key = `note_${id || ''}`
	}

	withCreatedAt(dateStr) {
		if (dateStr) {
			this.createdAt = parseDate(dateStr)
		}
		return this
	}

	withAuthor(json) {
		this.author = json ? parsePerson(json) : null
		return this
	}

	withNote(note) {
		this.note = note
		return this
	}

	withReminderDate(dateStr) {
		if (dateStr) {
			this.reminderDate = parseDate(dateStr)
		}
		return this
	}

	withReminder(reminder) {
		this.reminder = reminder
		return this
	}

	withEmphasize(emphasize) {
		this.emphasize = emphasize
		return this
	}

	withProcessId(processId) {
		this.processId = processId
		return this
	}
}
